import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { MyPageTitle, MyPageTemplate, Release } from 'components';

class CtRelease extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <MyPageTemplate>
        <MyPageTitle
          small
          title={defineMessages(formatMessage({ id: 'MyPageMenu_6', defaultMessage: '릴리즈 노트' }))}
        />
        <Release />
      </MyPageTemplate>
    );
  }
}

export default injectIntl(CtRelease);



// WEBPACK FOOTER //
// ./src/script/containers/mypage/CtRelease.js